/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {EmGroup} from './em-group';
import {Image} from "./image";
import {Property} from './property';

export abstract class BaseEntity {
  id: number;
  name: string;
  parent: BaseEntity;
  description: string;
  image: Image;
  icon: Image;
  driver: string;
  uuid: string;
  
  properties: Property[];
  groups: EmGroup[];
}
